import type { ReactNode } from 'react'
import { CallProvider } from '@/webrtc/CallProvider'
import type { LessonCallStateEvent } from '@/webrtc/callContext'

/**
 * Контекст звонка вокруг страницы урока.
 *
 * Провайдер монтируется всегда, а «выключенное» состояние передаётся пропом:
 * условный рендер (`<>{children}</>` против `<CallProvider>{children}</CallProvider>`)
 * менял бы тип корневого элемента, и React пересоздавал бы всю страницу урока
 * при каждой загрузке данных и при старте/завершении занятия.
 */
type LessonCallScopeProps = {
  enabled: boolean
  lessonId: number
  selfId: number | null
  canManage: boolean
  callState: LessonCallStateEvent | null
  children: ReactNode
}

export function LessonCallScope({
  enabled,
  lessonId,
  selfId,
  canManage,
  callState,
  children,
}: LessonCallScopeProps) {
  return (
    <CallProvider
      enabled={enabled && selfId !== null}
      lessonId={lessonId}
      selfId={selfId ?? 0}
      canManage={canManage}
      callState={callState}
    >
      {children}
    </CallProvider>
  )
}
